import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { CloseIcon } from './UIComponents'
import { CLAIM_STEPS } from './constants'
import { UploadIcon, RefundIcon } from './icons'
import styles from './VdcEducationPage.module.scss'

const CLAIM_ICONS = {
  cross: <CloseIcon stroke="#7D38D3" />,
  upload: <UploadIcon />,
  refund: <RefundIcon />
} as const

const HowToClaim: React.FC = () => (
  <Container className={`${styles.claim} flex flex-column`}>
    <div className={styles['claim__line']} />
    {CLAIM_STEPS.map((step) => (
      <Container key={step.text} className={`${styles['claim__step']} flex flex-middle`}>
        <Container className={`${styles['claim__stepIcon']} flex flex-middle flex-center`}>
          {CLAIM_ICONS[step.icon]}
        </Container>
        <Typography variant="P2" className={styles['claim__stepText']}>{step.text}</Typography>
      </Container>
    ))}
  </Container>
)

export default HowToClaim

